import React from 'react';
import { Card, Button } from 'antd';
import pdfData from './contract.pdf';

const Sanatera = () => {
	document.title = "Dogovor | Archi-crm";

	return (
		<Card>
			<object
				data={pdfData}
				type="application/pdf"
				width="100%"
				height="800px"
			>
			</object>
			<Button href={pdfData} type='primary' download>Скачать документ</Button>
		</Card>
	)
}


export default Sanatera;